import React, { useState, useEffect } from 'react';
import "./ScheduleHeader.scss";
import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import MonthSelector from '../../UI/MonthSelector/MonthSelector';
import ScheduleConfirm from '../../UI/ScheduleConfirm/ScheduleConfirm';
import ScheduleCreate from '../../UI/ScheduleCreate/ScheduleCreate';
import Specialists from '../../Specialists/Specialists/Specialists';
import { setSlotsAction, setCurrentScheduleAction, setConfirmed } from '../../../store/scheduleReducer';

const ScheduleHeader = ({ toggleAltSchedule = null, isAltSchedule = null, isHeaderHidden = false, ref = null }) => {
	const dispatch = useDispatch();
	const period = useSelector(state => state.schedule.period);
	const slots = useSelector(state => state.schedule.slots);
	const currentSchedule = useSelector(state => state.schedule.currentSchedule);
	const confirmed = useSelector(state => state.schedule.confirmed);
	const [currMonth, setCurrMonth] = useState(null);
	const [isCreated, setIsCreated] = useState(false);
	const [isCleared, setIsCleared] = useState(false);


	const convertDateFormat = (date) => {
		const dateParts = date.split('-');
		return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
	}

	useEffect(() => {
		if (period) {
			const date = convertDateFormat(period[0]);
			setCurrMonth(date)
			fetchList(date)
		}
	}, [period])

	useEffect(() => {
		if (period) {
			const date = convertDateFormat(period[0]);
			setCurrMonth(date)
			fetchList(date)
		}
		fetchSlots();

	}, [])

	useEffect(() => {
		fetchSlots();
	}, [currentSchedule])

	useEffect(() => {
		if (slots.length > 0) setIsCleared(false);
		else setIsCleared(true);

	}, [slots])

	const [fetchList] = useFetching(async (date) => {
		const response = await PostService.getAnyPlainMonthLists(date);

		if (response.data.success && response.data.result.length > 0) {
			dispatch(setCurrentScheduleAction(response.data.result[0].id));
			setIsCreated(true)
			if (response.data.result[0].draft == 0) {
				dispatch(setConfirmed(true));
			} else {
				dispatch(setConfirmed(false));
			}
		} else {
			setIsCreated(false)
			dispatch(setCurrentScheduleAction(null));
		}
	})

	const [fetchSlots] = useFetching(async () => {
		const response = await PostService.getListItems(currentSchedule);

		if (response.data.success && response.data.result !== false) {
			const slots = response.data.result[currentSchedule];
			dispatch(setSlotsAction(slots));
		}

		if (!response.data.result) {
			setIsCleared(true);
		}
	})

	const [fetchCreateList] = useFetching(async (date) => {
		const response = await PostService.addScheduleList(JSON.stringify(date));

		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentScheduleAction(response.data.result));
			fetchSlots(response.data.result);
			setIsCreated(true)
		}
	});

	const [fetchConfirmList] = useFetching(async () => {
		const response = await PostService.confirmScheduleList(currentSchedule);

		if (response.data.success && response.data.result !== false) {
			dispatch(setConfirmed(true));
		}
	});

	const [fetchClearList] = useFetching(async (date) => {
		const response = await PostService.clearMonthLists(date);

		if (response.data.success && response.data.result !== false) {
		}
	});

	const [fetchFillList] = useFetching(async () => {
		const response = await PostService.fillList(currentSchedule);

		if (response.data.success && response.data.result !== false) {
			fetchSlots(response.data.result);
			setIsCleared(false)
		}
	});


	const handleClick = () => {
		fetchCreateList(currMonth);
	}

	const handleConfirm = () => {
		fetchConfirmList();
	}

	const handleClear = () => {
		fetchClearList(currMonth);
		dispatch(setSlotsAction([]));
	}

	const handleFill = () => {
		fetchFillList();
	}

	return (
		<div className={"schedule-header" + (isHeaderHidden ? ' header-hidden' : '')} ref={ref}>
			<div className="app-container">
				<div className="schedule-header__inner">
					<div className="schedule-header__period">
						<MonthSelector />
					</div>
					<div className="schedule-header__buttons">
						{!!isCreated ? (
							<>
								<ScheduleConfirm
									handleClear={handleClear}
									isConfirmed={confirmed}
									isCleared={isCleared}
									handleClick={handleConfirm}
									handleFill={handleFill}
									schedule={currentSchedule} />
							</>
						) : (
							<>
								<ScheduleCreate
									handleClick={handleClick} />
							</>
						)}
					</div>
					<button onClick={toggleAltSchedule} className="schedule-header__toggle g-button">
                        {isAltSchedule ? 'График по салонам' : 'График по специалистам'}
					</button>
					<div className="schedule-header__specialists">
						<Specialists />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ScheduleHeader;
